<template lang="pug">
.stages
    h2 {{$t(`${baseTranslationPath}.stages_title`)}}

.body-section
  .group-item(v-for="(stage, index) in getStages" :key="stage.id")
    aiq-collapse
      aiq-collapse-item(:title="getName(stage)")
        .group-reviewers(v-if="showGroup(stage, 'actors')")
          h3 {{ $t(`${baseTranslationPath}.reviewers`)}}
          .person(v-for="r in stage.actors" :key="r.id")
            span {{ r.name }} {{ getTime(r.done_at) }}
            aiq-tooltip(:content="r.status")
              fa-icon(v-if="r.status === 'approve'" class="icon success-icon" :icon="['fas', 'check']")
              fa-icon(v-if="r.status === 'reject'" class="icon reject-icon" :icon="['fas', 'times']")
              fa-icon(v-if="r.status === 'created' || r.status === 'create'" class="icon success-icon" :icon="['fas', 'plus']")
        .group-assignees(v-if="showGroup(stage, 'assignees')")
          h3 {{ $t(`${baseTranslationPath}.assignees`)}}
          .person(v-for="a in stage.assignees" :key="a.id")
            span {{ a.name }} ({{ a.assignee_type }})

        .group-btn(v-if="canReview")
          aiq-button(type="primary" :disabled="!isCurrentStage(stage)" class="group-btn" @click="action('approve')") {{ $t(`${baseTranslationPath}.approve`) }}
          aiq-button(type="danger" :disabled="!isCurrentStage(stage)" class="group-btn" @click="action('reject')") {{ $t(`${baseTranslationPath}.reject`) }}

.reject-modal-editor
    aiq-dialog.modal-editor(:title="$t(`${baseTranslationPath}.reject`)"
        v-model="showRejectModal"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        @closed="closeEditor")
        .field-container.full-width.is-required
            label {{ $t(`${baseTranslationPath}.reject_reason`) }}
            aiq-input(v-model="rejectReason"
                        :max-length="250"
                        type="textarea")
        .field-container.full-width.reject-btn
            aiq-button(type="primary" :disabled="!rejectReason" class="group-btn" @click="reject") {{ $t(`${baseTranslationPath}.reject`) }}
</template>
<script>
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';

export default {
  name: 'ControlListStages',
  props: {
    smartControlRecord: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getStages() {
      return get(this.smartControlRecord, 'stages', []);
    },
    canReview() {
      return get(this.smartControlRecord, 'can_act', false);
    },
  },
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      showRejectModal: false,
      rejectReason: '',
    };
  },
  emits: ['act'],

  methods: {
    isCurrentStage(stage) {
      const currentStage = get(this.smartControlRecord, 'current_stage.name');
      const stageName = get(stage, 'name');
      return stageName === currentStage;
    },
    showGroup(stage, groupName) {
      const group = get(stage, groupName, []);
      return Array.isArray(group) && group.length > 0;
    },
    getName(stage) {
      const name = get(stage, 'name', '');
      if (this.isCurrentStage(stage)) {
        return `${name} (${this.$t(`${this.baseTranslationPath}.current_stage`)})`;
      } else {
        return name;
      }

    },
    getTime(date) {
      if (date) {
        return `(${dayjs(date).format('MM/DD/YYYY hh:mm A')})`;
      }
    },
    async approveConfirm() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.baseTranslationPath}.approval_confirm.title`),
          this.$t(`${this.baseTranslationPath}.approval_confirm.message`),
        );
        return true;
      } catch {
        return false;
      }
    },

    async action(action) {
      if (action === 'approve') {
        if (await this.approveConfirm()) {
          this.$emit('act', {
            action: action,
          });
        }
      } else if (action === 'reject') {
        this.showRejectModal = true;
      }
    },
    closeEditor() {
      this.showRejectModal = false;
      this.rejectReason = '';
    },

    reject() {
      this.$emit('act', {
        action: 'reject',
        reason: this.rejectReason,
      });
      this.closeEditor();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/styles/aiq-variables.scss';

.stages {
    margin-top: 20px;
}

h3 {
    margin-bottom: 10px;
    font-weight: bold;
}

.success-icon {
    color: $aiq-status-success-light;
}

.reject-icon {
    color: $aiq-status-error-light;
}

.group-assignees {
    padding-top: 10px;
}

.person {
    margin-left: 10px;
    margin-right: 10px;
}
.icon {
    margin-left: 15px;
}
.group-btn {
    display: flex;
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 20px;
    padding-bottom: 10px;
    margin-bottom: auto;
}

.stage-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 10px;
}

.group-name {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.body-section {
  padding-top: 15px;
}

.reject-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.stage-item {
    padding-left: 10px;
    width:100%;
    height:100%;
}

:deep(.el-collapse .el-collapse-item__header) {
 background-color: var(--aiq-bgc-list-item-selected) !important;
 color: var(--aiq-bgc-list-item) !important;
 word-wrap: break-word !important;
 height: 40px;
}

:deep(.el-collapse .el-collapse-item__header:hover) {
  background-color: var(--aiq-bgc-list-item-selected) !important;
  color: var(--aiq-bgc-list-item) !important;
  word-wrap: break-word !important;
  height: 40px;
}
:deep(.el-collapse .el-collapse-item__header .el-collapse-item__arrow) {
  color: var(--aiq-bgc-list-item) !important;
}
:deep(.el-collapse-item__header) {
  line-height: 20px;
  font-size: 12px;
}

</style>